import { render, staticRenderFns } from "./ContactReservations.vue?vue&type=template&id=1c277aaf&"
import script from "./ContactReservations.vue?vue&type=script&lang=js&"
export * from "./ContactReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports